export default __webpack_public_path__ + "static/media/cl21.ded3b9c5.webp";